import type React from "react";
import { useDrag } from "react-dnd";
import style from "./Word.module.scss";

type Props = {
	word: { word: string; originalIndex: number };
	matchWithAudio?: boolean;
};
export const Word: React.FC<Props> = ({ word }) => {
	const [{ isDragging }, drag] = useDrag({
		type: "words-defs",
		item: { word },
		canDrag: word.word !== "",
		collect: (monitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
	});

	const prefixClass = "fill-in-gaps";

	return (
		<li
			className={style[`${prefixClass}__word-item`]}
			ref={drag}
			style={{ opacity: isDragging ? 0.5 : 1 }}
		>
			<p>{word.word}</p>
		</li>
	);
};
